export const screenSizeMixin = {
  data () {
    return {
      screenHeight: 0,
      screenWidth: 0
    }
  },
  methods: {
    getHeightWidth () {
      this.screenHeight = window.innerHeight
      this.screenWidth = window.innerWidth
    }
  },
  created () {
    window.addEventListener('resize', this.getHeightWidth)
    this.getHeightWidth()
  }
}
